import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Ticket } from './index';

export interface TicketByIdGetParams {
  id: string;
}

export const ticketById = (payload: TicketByIdGetParams): Action<TicketByIdGetParams> => ({
  type: actions.ticketByIdTrigger.toString(),
  payload,
});

export const ticketByIdClear = (): Action => ({
  type: actions.ticketByIdClear.toString(),
});

export function* ticketByIdRequestSaga({ payload }: Action<TicketByIdGetParams>) {
  yield put({
    type: actions.ticketByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.ticketByIdError.toString(),
      payload: {
        message: 'TicketById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/tickets/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Ticket, Ticket>(
    response,
    actions.ticketByIdSuccess.toString(),
    actions.ticketByIdError.toString(),
    false,
    (ticketByIdData) => ticketByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.ticketByIdTrigger.toString(),
    defaultProcessingSaga(
      ticketByIdRequestSaga,
      {
        error: actions.ticketByIdError.toString(),
        locationCancel: actions.ticketByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.ticketByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.ticketByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.ticketByIdErrorReset.toString(),
    });
  });
}
